import React, { useState, useCallback, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Table from 'react-bootstrap/Table';

const MyVerticallyCenteredModal = ({ validNameEmpresa, permissions, units, show, handleChangeChartModal, onHide }) => {

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectionType, setSelectionType] = useState("chart_p");

  useEffect(() => {
    const idsSet = new Set();
    const initialSelections = units.reduce((acc, company) => {
      if (!idsSet.has(company._id)) {
        idsSet.add(company._id);
        acc.push({
          _id: company._id,
          chart_p: company.chart_p || "P_0",
          chart_m: company.chart_m || "P_0"
        });
      }
      return acc;
    }, []);

    setSelectedOptions(initialSelections);
  }, [units]);


  const handleSelectionChangeP = useCallback((companyId, option) => {
    setSelectedOptions((prevState) => {
      return prevState.map(item =>
        item._id === companyId ? { ...item, chart_p: option } : item
      ).concat(prevState.some(item => item._id === companyId) ? [] : [{ _id: companyId, chart_p: option }]);
    });
  }, []);

  const handleSelectionChangeM = useCallback((companyId, option) => {
    setSelectedOptions((prevState) => {
      return prevState.map(item =>
        item._id === companyId ? { ...item, chart_m: option } : item
      ).concat(prevState.some(item => item._id === companyId) ? [] : [{ _id: companyId, chart_m: option }]);
    });
  }, []);


  const handleSave = () => {
    handleChangeChartModal(selectedOptions);
  };

  const selectAllInColumn = (option) => {
    const updatedOptions = units.map((company) => {
      const existingSelection = selectedOptions.find(item => item._id === company._id) || {};

      return {
        _id: company._id,
        chart_p: selectionType === "chart_p" ? option : existingSelection.chart_p || "", // Mantém chart_p se estiver alterando chart_m
        chart_m: selectionType === "chart_m" ? option : existingSelection.chart_m || "", // Mantém chart_m se estiver alterando chart_p
      };
    });

    setSelectedOptions(updatedOptions);
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen
      show={show}
      onHide={onHide}
      className="modal-dark"
    >
      <Modal.Header
        closeButton
        className="border-0"
        style={{
          background: "rgba(15, 23, 42, 0.98)",
          color: "#e5e7eb"
        }}
      >
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="fw-semibold"
        >
          Selecionar Preferências
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="text-white"
        style={{
          background: "radial-gradient(circle at top, #020617 0, #020617 40%, #000000 100%)"
        }}
      >

        <div className="d-flex justify-content-between flex-wrap mt-2 mb-3 align-items-center gap-2">
          <div>
            <small className="text-uppercase text-secondary">Aplicar em</small>
            <div>
              <Form.Check
                inline
                label="Recebendo"
                name="selectionType"
                type="radio"
                id="select-chart-p"
                checked={selectionType === "chart_p"}
                onChange={() => setSelectionType("chart_p")}
              />
              <Form.Check
                inline
                label="Expedindo"
                name="selectionType"
                type="radio"
                id="select-chart-m"
                checked={selectionType === "chart_m"}
                onChange={() => setSelectionType("chart_m")}
              />
            </div>
          </div>

          <div className="me-3 text-end">
            <small className="text-uppercase text-secondary d-block mb-1">
              Ações rápidas
            </small>
            {['P_0M5', 'P_0M3', 'P_0', 'P_0P5', 'P_0P75', 'P_1P', 'P_1P5', ...(validNameEmpresa ? ['P_2P'] : [])].map((option) => (
              <Button
                key={option}
                variant="outline-success"
                size="sm"
                className="me-2 mb-1"
                onClick={() => selectAllInColumn(option)}
              >
                Todos para {option}
              </Button>
            ))}
          </div>
        </div>

        <Table
          style={{ fontSize: "0.9rem", borderRadius: 8, overflow: "hidden" }}
          striped
          bordered
          hover
          responsive
          size="sm"
          variant="dark"
        >
          <thead>
            <tr>
              <th className="text-center">Unidade</th>
              <th className="text-center">Tipo</th>
              <th className="text-center" colSpan={8}></th>
            </tr>
          </thead>

          <tbody>
            {units.map((company) => (
              <React.Fragment key={company._id}>
                <tr className="text-center">
                  {/* Nome da empresa ocupando duas linhas */}
                  <td
                    rowSpan={2}
                    className="align-middle fw-semibold text-start px-3"
                    style={{ maxWidth: 260 }}
                  >
                    <div className="text-truncate" title={company?.name || "--"}>
                      {company?.name || "--"}
                    </div>
                  </td>
                  <td>Recebendo</td>
                  {['P_0M5', 'P_0M3', 'P_0', 'P_0P5', 'P_0P75', 'P_1P', 'P_1P5', ...(validNameEmpresa ? ['P_2P'] : [])].map((option) => (
                    <td key={`${company._id}-p-${option}`}>
                      <Form.Check
                        isValid
                        inline
                        type="radio"
                        label={option}
                        name={`company-${company._id}-p`}
                        id={`company-${company._id}-option-${option}-p`}
                        checked={selectedOptions.some(item => item._id === company._id && item.chart_p === option)}
                        onChange={() => handleSelectionChangeP(company._id, option)}
                        disabled={company?.pp}
                      />
                    </td>
                  ))}
                </tr>
                <tr className="text-center">
                  <td>Expedindo</td>
                  {['P_0M5', 'P_0M3', 'P_0', 'P_0P5', 'P_0P75', 'P_1P', 'P_1P5', ...(validNameEmpresa ? ['P_2P'] : [])].map((option) => (
                    <td key={`${company._id}-m-${option}`}>
                      <Form.Check
                        isValid
                        inline
                        type="radio"
                        label={option}
                        name={`company-${company._id}-m`}
                        id={`company-${company._id}-option-${option}-m`}
                        checked={selectedOptions.some(item => item._id === company._id && item.chart_m === option)}
                        onChange={() => handleSelectionChangeM(company._id, option)}
                      />
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </Table>

      </Modal.Body>
      <Modal.Footer
        className="border-0"
        style={{
          background: "rgba(15, 23, 42, 0.98)",
          color: "#e5e7eb"
        }}
      >
        <Button variant="outline-light" size="sm" onClick={onHide}>
          Fechar
        </Button>
        <Button
          variant="success"
          size="sm"
          onClick={handleSave}
          disabled={!permissions?.restricted?.write}
        >
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MyVerticallyCenteredModal;
